"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Nav = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const React = __importStar(require("react"));
const clsx_1 = require("clsx");
const eventUtils_1 = require("../common/eventUtils");
const Nav = ({ items, activeItemId, onActiveTabChange, }) => {
    var _a;
    const tabs = [];
    const [activeNavItemId, setActiveNavItemId] = React.useState((_a = items === null || items === void 0 ? void 0 : items[0]) === null || _a === void 0 ? void 0 : _a.id);
    React.useEffect(() => {
        if (activeItemId) {
            setActiveNavItemId(activeItemId);
        }
    }, [activeItemId]);
    const handleClick = (item) => {
        setActiveNavItemId(item.id);
        if (onActiveTabChange) {
            onActiveTabChange(item);
        }
    };
    const handleKeydown = (key) => {
        var _a;
        const localDocument = (_a = tabs[0]) === null || _a === void 0 ? void 0 : _a.ownerDocument;
        const focusedElementIndex = tabs.findIndex(el => el === (localDocument === null || localDocument === void 0 ? void 0 : localDocument.activeElement));
        if (!localDocument || focusedElementIndex < 0)
            return;
        switch (key) {
            case eventUtils_1.Keys.ARROW_RIGHT:
                tabs[(focusedElementIndex + 1) % (tabs.length)].focus();
                break;
            case eventUtils_1.Keys.ARROW_LEFT:
                focusedElementIndex === 0 ? tabs[tabs.length - 1].focus() : tabs[focusedElementIndex - 1].focus();
                break;
        }
    };
    return ((0, jsx_runtime_1.jsx)("div", { className: "tk-nav", children: (0, jsx_runtime_1.jsx)("div", { role: "tablist", className: "tk-nav--tabs", children: items.map((item, idx) => ((0, jsx_runtime_1.jsx)("button", { role: "tab", ref: ref => { tabs[idx] = ref; }, id: 'tk-tab-' + item.id, "aria-controls": item.panelId && 'tk-panel-' + item.panelId, "aria-selected": activeNavItemId === item.id, onClick: () => handleClick(item), onKeyDown: (evt) => handleKeydown(evt.key), tabIndex: activeNavItemId === item.id ? 0 : -1, className: (0, clsx_1.clsx)('tk-nav-item', { 'tk-nav-item--active': activeNavItemId === item.id }), children: item.label }, item.id))) }) }));
};
exports.Nav = Nav;
exports.default = exports.Nav;
